import { useFlag } from '@calendly/feature-check-react'

import { ET_EDITOR_VARIANTS, type EtEditorVariant } from 'shared/constants/et_editor'

import { useEtEditorQueryParam } from './etEditorQueryParam'
import { EVENT_TYPE_EDITOR_CRUD_GATE } from '../tabs/registry'

interface EtCrudEditorGateState {
  isAllocated: boolean
  editorVariant: EtEditorVariant | null
  shouldUseCrudEditor: boolean
}

/**
 * Decides whether the full-page CRUD editor should be used.
 *
 * No `et_editor` → `sa_et_crud_single_host` only.
 * `?et_editor=new` → force CRUD; `?et_editor=classic` → force classic.
 */
export function useEtCrudEditorGateState(): EtCrudEditorGateState {
  const isAllocated = Boolean(useFlag(EVENT_TYPE_EDITOR_CRUD_GATE))
  const editorVariant = useEtEditorQueryParam()

  let shouldUseCrudEditor = isAllocated
  if (editorVariant === ET_EDITOR_VARIANTS.NEW) shouldUseCrudEditor = true
  if (editorVariant === ET_EDITOR_VARIANTS.CLASSIC) shouldUseCrudEditor = false

  return {
    isAllocated,
    editorVariant,
    shouldUseCrudEditor,
  }
}

/** CRUD routes when allocated, or when `?et_editor=new` forces them on. */
export function useEtCrudEditorRoutesEnabled(): boolean {
  const isAllocated = Boolean(useFlag(EVENT_TYPE_EDITOR_CRUD_GATE))
  const editorVariant = useEtEditorQueryParam()
  if (editorVariant === ET_EDITOR_VARIANTS.NEW) return true
  return isAllocated
}
